/*
 * @Author: cheesekun
 * @Date: 2021-03-24 15:53:39
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-08-31 16:48:51
 * @FilePath: \dc-vizier-tpl-h5\src\utils\index.js
 */

/**
 * @description: 获取url 上的query
 * @param {String} name key值
 * @return {String} 编码后的val
 */
export function getQueryString (name) {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  const r = window.location.search.substr(1).match(reg)
  if (r !== null) {
    return decodeURIComponent(r[2])
  }
  return null
}

/**
 * @description: 获取前缀转化后的css
 * @param {Object} originCssObj
 * @return {Object}
 */
export function transformCssPrefix (originCssObj) {
  const needPatchProperty = ['transform', 'transition']
  Object.keys(originCssObj).forEach(key => {
    if (needPatchProperty.includes(key)) {
      const patchKey = `-webkit-${key}`
      originCssObj[patchKey] = originCssObj[key]
    }
  })
  return originCssObj
}

export const userAgent = function () {
  var u = navigator.userAgent
  const browser = {
    // 移动终端浏览器版本信息
    trident: u.indexOf('Trident') > -1, // IE内核
    presto: u.indexOf('Presto') > -1, // opera内核
    webKit: u.indexOf('AppleWebKit') > -1, // 苹果、谷歌内核
    gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') === -1, // 火狐内核
    mobile: !!u.match(/AppleWebKit.*Mobile.*/), // 是否为移动终端
    iPad: u.indexOf('iPad') > -1, // 是否iPad
    webApp: u.indexOf('Safari') === -1 // 是否web应该程序，没有头部与底部
  }
  const language = (
    navigator.browserLanguage || navigator.language
  ).toLowerCase()
  return {
    ...browser,
    language
  }
}
